import React, { Component } from "react";
import BuildCatalog from "./buildCatalog";
import StorePreview from "./storePreview";

class BuildMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPreview: false,
    };
  }
  onChangePreview = () => {
    this.setState({
      isPreview: !this.state.isPreview,
    });
  };
  render() {
    return (
      <div>{!this.state.isPreview ? <BuildCatalog  onChangePreview={this.onChangePreview}/> : <StorePreview onChangePreview={this.onChangePreview} />}</div>
    );
  }
}
export default BuildMain;
